var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Fazer Download da Trilha'),expression:"'Fazer Download da Trilha'"}],staticClass:"download",attrs:{"href":_vm.url}},[_c('i',{staticClass:"fa fa-download",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }